import { FC } from 'react';

import { Typography } from '@mui/material';

import { styles } from './styles';

export const NotificationsEmptyState: FC = () => {
  return <Typography sx={styles.message}>Future notifications will appear here.</Typography>;
};
